<template>
    <div class="map-box">
        <div class="map--privacy-messages" v-if="!loaded">
            <p>
                Zum Aktivieren von Google Maps benötigen wir Ihre jederzeit widerrufliche Einwilligung.
                Hierfür klicken Sie bitte auf den nachfolgenden Link. Wir weisen darauf hin, dass nach der
                Aktivierung Cookies gesetzt und Daten an Google übermittelt werden. Weitere Informationen
                entnehmen Sie bitte der <a href="https://www.amecke.de/#/datenschutzerklaerung" target="_blank" rel="noopener">Datenschutzerklärung</a>.
            </p>
            <p>
                <button @click="loadMap" class="btn">Google Maps aktivieren</button>
            </p>
        </div>
        <div class="map" :class="{disabled: !loaded}" ref="map">
        </div>
    </div>
</template>

<script>
const googleMapsApiKey = process.env.NODE_ENV === 'development'
    ? (process.env.MIX_GOOGLE_MAPS_API_KEY_PROD || '')
    : (process.env.MIX_GOOGLE_MAPS_API_KEY_DEV  || '');

let markers = [];

export default {
    name: "MapBox",

    data() {
        return {
            enabled: false,
            loaded: false,
            markers: [],
            map: null,
        }
    },

    computed: {
        mapScriptUrl() {
            return `https://maps.googleapis.com/maps/api/js?key=${googleMapsApiKey}&callback=sfAmeckePartnerMapCb`;
        },

        partners() {
            return this.$store.state.partners !== null
                ? this.$store.state.partners
                : [];

        }
    },

    watch: {
        partners: {
            deep: true,
            handler: function () {
                this.setMarkers();
            }
        }
    },

    methods: {
        loadMap() {
            if (this.enabled) {
                return;
            }

            this.enabled = true;

            const script = document.createElement('script');
            script.async = true;
            script.src = this.mapScriptUrl;
            this.$el.append(script);
        },

        setMarkers() {
            if (!this.loaded) {
                return;
            }

            markers.forEach(marker => marker.setMap(null));
            markers = [];

            let bounds = new google.maps.LatLngBounds();

            this.partners
                .filter(partner => !partner.show_always)
                .forEach(partner => {
                    const latLng = new google.maps.LatLng(partner.latitude, partner.longitude);

                    const marker = new google.maps.Marker({
                        position: latLng,
                        title: partner.title
                    });

                    const infoWindow = new google.maps.InfoWindow({
                        content: `<strong>${partner.title}</strong>`,
                    });

                    marker.addListener('click', () => {
                        infoWindow.open({
                            anchor: marker,
                            map: this.map,
                            shouldFocus: false,
                        });
                    });

                    markers.push(marker);
                    marker.setMap(this.map);
                    bounds.extend(latLng);
                });

            this.map.fitBounds(bounds);

            if (this.map.getZoom() > 15) {
                this.map.setZoom(15);
            }
        }
    },

    mounted() {
        window.sfAmeckePartnerMapCb = () => {
            this.map = new google.maps.Map(this.$refs.map, {
                zoom: 6,
                center: {
                    lat: 51.165691,
                    lng: 10.451526
                },
            });

            this.loaded = true;

            this.setMarkers();
        };
    },

    beforeUnmount() {
        delete window.sfAmeckePartnerMapCb;
    }
}
</script>
